import ExpirationStorage from './ExpirationStorage';
import {checkPops} from '@/app.service';
import {imageCache} from '@utils/preloadImage';
type ModalData = {
  remind: number;
  origin: number;
  id: number | string;
  used: boolean;
};

export interface SequentialItem {
  popImg: string; // 图片
  popUrl: string; //跳转信息
  /** 0开启1关闭 */
  status: 0 | 1;
  title: string;
  dailyImpressions?: number;
  bannerId: number;
}
type SequentialStorageProps = {
  data: SequentialItem[];
};
const UNIKEY = 'bannerId';
const SEQUENTIAL_KEY = 'sequential_storage';
const RECHARGE_GIFT_TITLE = 'RECHARGE_GIFT_EVENT';
class SequentialStorage extends ExpirationStorage<ModalData> {
  private _rawData: SequentialItem[] = [];
  get rawData() {
    return this._rawData;
  }
  set rawData(val) {
    this._rawData = val;
    // 如果不存在或者过期重新创建一个
    if (!this.isValid()) {
      this.resetSequential();
    } else {
      // 合法那么就要判断是否更新
      this.updateSequential();
    }
    const len = 2;
    const high = this.remindData.slice(0, len).map(item => item.popImg);
    const low = this.remindData.slice(len).map(item => item.popImg);
    imageCache.preloadImagesByPriority(high, low).then(() => {
      this.emit('updated', this.remindData);
    });
  }
  get remindData() {
    const store = this.sequentialData;
    if (!store) {
      return this.rawData.filter(item => item.title === RECHARGE_GIFT_TITLE);
    }
    return this.rawData.filter(item => {
      if (item.title === RECHARGE_GIFT_TITLE) {
        return true;
      }
      const storeValue = store[item[UNIKEY]];
      if (!storeValue) {
        return false;
      }
      // 使用过的不做显示
      if (store[item[UNIKEY]].used) {
        return false;
      }
      return (
        store[item[UNIKEY]].origin === -1 || store[item[UNIKEY]].remind > 0
      );
    });
  }
  get sequentialData() {
    return this.get();
  }
  constructor(props?: Partial<SequentialStorageProps>) {
    super(SEQUENTIAL_KEY, 1);
    const {data = []} = props || {};
    this.rawData = data;
  }
  // 更新序列存储
  // 消费本地数据
  consumerSequential(key: string) {
    const store = this.sequentialData;
    if (store) {
      const currentItem = store[key];
      if (!currentItem) {
        store[key] = {
          origin: 1,
          remind: 0,
          used: true,
          id: key,
        };
        this.update(store);
        return;
      }
      store[key] = {
        ...currentItem,
        used: true,
        remind: currentItem.remind - 1,
      };
      this.update(store);
    } else {
      throw new Error('Sequential storage is not valid');
    }
  }
  isSequentialConsumed(key: string) {
    return !!this.sequentialData?.[key]?.used;
  }
  // 只是远程数据和本地进行更新
  updateSequential() {
    const store = this.sequentialData;
    if (!store) {
      return;
    }
    this.rawData.forEach(item => {
      let originDailyImpressions = item.dailyImpressions;
      if (typeof originDailyImpressions !== 'number') {
        originDailyImpressions = -1;
      }
      if (!originDailyImpressions) {
        delete store[item[UNIKEY]];
        return;
      }
      if (!store.hasOwnProperty(item[UNIKEY])) {
        store[item[UNIKEY]] = {
          origin: originDailyImpressions,
          remind: originDailyImpressions,
          used: false,
          id: item[UNIKEY],
        };
      } else {
        const localDailyImpressions = store[item[UNIKEY]].origin;
        if (originDailyImpressions !== localDailyImpressions) {
          // 重置
          store[item[UNIKEY]] = {
            origin: originDailyImpressions,
            remind: originDailyImpressions,
            used: false,
            id: item[UNIKEY],
          };
        } else {
          // 因为第一次进来 对于这个数据需要重置使用状态
          store[item[UNIKEY]].used = false;
        }
      }
    });
    this.update(store);
  }
  // 重置序列存储
  resetSequential() {
    const newStore: Record<string, ModalData> = {};
    this.rawData.forEach(item => {
      let originDailyImpressions = item.dailyImpressions;
      if (typeof originDailyImpressions !== 'number') {
        originDailyImpressions = -1;
      }
      if (!originDailyImpressions) {
        return;
      }
      newStore[item[UNIKEY]] = {
        remind: originDailyImpressions,
        origin: originDailyImpressions,
        used: false,
        id: item[UNIKEY],
      };
    });
    this.set(newStore);
  }
  loadData(reset = false) {
    if (reset) {
      this.clear();
    }
    checkPops().then(res => {
      const popList = res
        .filter(item => item.status === 1)
        .map(item => {
          return {
            ...item,
            bannerId: item.bannerId || Math.random(),
          };
        });
      this.rawData = popList;
    });
  }
}

export const sequentialStorage = new SequentialStorage();
